import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ErrorCover from "../images/error_cover.svg";
import EmailSuccess from "../images/email_success.svg";
import Image from "react-bootstrap/Image";
import Spinner from "react-bootstrap/Spinner";
import { verifyEmail } from "../api/mainApi";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const VerifyEmail = () => {
  let params = useParams();

  // Queries

  // Mutations
  const verifyEmailMutation = useMutation({
    mutationFn: (data) => verifyEmail(data),
    onSuccess: async (data) => {
      console.log("Email verified successfully", data);
    },
    onError(error) {
      console.log("Email verification failed", error);
    },
  });

  useEffect(() => {
    verifyEmailMutation.mutate({ email_token: params?.token });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.token]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Verify Email</title>
        <link rel="canonical" href="https://boque.me/verify-email" />
        <meta name="description" content="Verify Email Address." />
      </Helmet>
      <div
        className="header-small"
        style={{ backgroundImage: "url(/images/tile_background.png)" }}
      >
        <Container>
          <Row>
            <Col>
              <h1>Verify Email Address</h1>
            </Col>
          </Row>
        </Container>
      </div>
      {verifyEmailMutation.isLoading && (
        <Spinner animation="grow" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )}
      {verifyEmailMutation.isSuccess && (
        <Container>
          <Row className="mt-3">
            <Col md={12}>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <Image src={EmailSuccess} width="200px" height="200px" />
                <h4 className="mt-3">Email Verified Successfully</h4>
                <p className="text-center">
                  Email has been verified, proceed to app.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      )}
      {verifyEmailMutation.isError && (
        <Container>
          <Row className="mt-3">
            <Col md={12}>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <Image src={ErrorCover} width="200px" height="200px" />
                <h4 className="mt-3">Verification Failed</h4>
                <p className="text-center">
                  Check the link to make sure its correct.
                </p>
                <p className="text-center">
                  Check to make sure your internet connection is available.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default VerifyEmail;
